import React, {Component} from "react"

import {ModalHeader} from "@irati-web/recognition/src/components/Popup/shared/Modal"
import {RewardOrder} from "@irati/types"
import {rewardTracking} from "@irati-tracking/reward"
import GenericModal from "@irati/ui/src/GenericModal"

import InnerReceipt from "./InnerReceipt"

interface Props {
  buttonText: string
  onClose: () => void
  rewardOrder: RewardOrder
}

class Receipt extends Component<Props> {
  componentDidMount() {
    if (this.props.rewardOrder.reward?.isCredit) {
      rewardTracking.rewardsTabCreditSend()
    }
  }

  render() {
    const {buttonText, onClose, rewardOrder} = this.props
    return (
      <GenericModal show useMobileStyling={false} onHide={onClose} onExited={onClose}>
        <ModalHeader users={rewardOrder.recipients.results} size={150} />
        <InnerReceipt rewardOrder={rewardOrder} onClose={onClose} buttonText={buttonText} />
      </GenericModal>
    )
  }
}

export default Receipt
